import { defineMessages } from 'react-intl';

const messages = defineMessages({
  RetryButton: {
    defaultMessage: 'Retry'
  }
});

export default messages;
